import { ROUTES, withLocale } from "@/config/routes";
import { getCleanPathname } from "@/shared/lib/getCleanPathname";
import { CopyTrade, HelpCenter, MenuTradingProfile, Trade, Transactions, Wallet } from "@cronika/assets/icons";
import { useTranslation } from "@cronika/locales";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const NAVIGATION_ITEMS = [
  {
    key: "trading",
    icon: Trade,
    route: ROUTES.HOME,
    matchExact: true,
    translationKey: "sidebar.trading-btn",
    mobileOrder: 3,
  },
  {
    key: "wallet",
    icon: Wallet,
    route: ROUTES.WALLET,
    matchExact: false,
    translationKey: "sidebar.wallet-btn",
    mobileOrder: 1,
  },
  // {
  //   key: "wallet",
  //   icon: Wallet,
  //   route: ROUTES.WALLET,
  //   matchExact: false,
  //   translationKey: "sidebar.wallet-btn",
  // },
  {
    key: "history",
    icon: Transactions,
    route: ROUTES.HISTORY,
    matchExact: false,
    translationKey: "sidebar.history-btn",
    mobileOrder: 2,
  },
  {
    key: "copy-trading",
    icon: CopyTrade,
    route: ROUTES.COPY_TRADING,
    matchExact: false,
    translationKey: "sidebar.copy-trading-btn",
    mobileOrder: 4,
  },
  {
    key: "profile",
    icon: MenuTradingProfile,
    route: ROUTES.SETTINGS,
    query: "?tab=trading-profile",
    matchExact: true,
    translationKey: "sidebar.profile-btn",
    mobileOrder: 5,
  },
  {
    key: "help-center",
    icon: HelpCenter,
    route: ROUTES.HELP_CENTER,
    matchExact: false,
    translationKey: "sidebar.help-center-btn",
    hiddenOnMobile: true,
    mobileOrder: 6,
  },
] as const;

export type NavigationItem = {
  key: string;
  icon: React.ComponentType<{ className?: string }> | string;
  route: string;
  query?: string;
  translationKey: string;
  matchExact: boolean;
  disabled?: boolean;
  hiddenOnMobile?: boolean;
  mobileOrder: number;
  active: boolean;
  link: string;
  title: string;
};

export function useNavigationItems(): NavigationItem[] {
  const { t } = useTranslation("layout");
  const location = useLocation();
  const cleanPathname = getCleanPathname(location.pathname);

  return useMemo(
    () =>
      NAVIGATION_ITEMS.map((item) => ({
        ...item,
        active:
          !("disabled" in item && item.disabled) &&
          (item.matchExact
            ? cleanPathname === item.route || (item.route === "/" && cleanPathname === "")
            : cleanPathname.includes(item.route)),
        link: withLocale(item.route) + ("query" in item ? item.query : ""),
        title: t(item.translationKey),
      })),
    [cleanPathname, t],
  );
}
